export const loginBranding = {
  eyebrow: "iTEMA FOR EDUCATORS",
  heading: "Welcome to",
  description:
    "Your own workspace for planning, prepping, and guiding your students, built for how you actually teach.",
  features: [
    {
      id: "lessons",
      text: "Plan lessons and track every student's progress in one place",
    },
    {
      id: "tools",
      text: "Built-in tools for your teaching role, not a generic dashboard",
    },
    {
      id: "students",
      text: "Your students get their own TutorCloud accounts, connected to your work here",
    },
  ],
  setupNote: "Takes about 2 minutes to set up.",
};

export const loginFormCopy = {
  title: "Sign in",
  subtitle: "Use your email and password to continue.",
  accountPrompt: "New to iTEMA?",
  createAccountLink: "Create an account",
  emailLabel: "Email address",
  emailPlaceholder: "ananya.sharma@school.edu",
  passwordLabel: "Password",
  passwordPlaceholder: "Enter your password",
  forgotPassword: "Forgot password?",
  submitLabel: "Sign in",
  submittingLabel: "Signing in…",
  termsPrefix: "By continuing, you agree to TutorCloud's",
  termsLabel: "Terms of Service",
  privacyLabel: "Privacy Policy",
};

export { authTheme as loginTheme } from "./authTheme";
